import { Card } from "../../../components/ui/card";
import { ArrowDownRight, ArrowUpRight } from "../../../components/icons";
import { centsToCurrency } from "../../utils/money";

interface MetricsSummaryCardsProps {
  lang: "pt" | "en";
  t: any;
  total: number;
  totalRevenue: number;
  hasPrev: boolean;
  diff: number;
  diffPct: number;
  hasPrevRevenue: boolean;
  diffRevenue: number;
  diffPctRevenue: number;
}

export function MetricsSummaryCards({
  lang,
  t,
  total,
  totalRevenue,
  hasPrev,
  diff,
  diffPct,
  hasPrevRevenue,
  diffRevenue,
  diffPctRevenue,
}: MetricsSummaryCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      <Card>
        <div className="p-4">
          <div className="text-sm text-neutral-500">{t.dashboard.totalAppointments}</div>
          <div className="text-2xl font-semibold">{total}</div>
          <div className="flex items-center gap-1 text-xs mt-1">
            {hasPrev ? (
              <>
                {diff >= 0 ? (
                  <ArrowUpRight className="w-3 h-3 text-green-500" />
                ) : (
                  <ArrowDownRight className="w-3 h-3 text-red-500" />
                )}
                <span className={diff >= 0 ? "text-green-600" : "text-red-600"}>
                  {diff >= 0 ? "+" : ""}{diffPct.toFixed(1)}%
                </span>
              </>
            ) : (
              <span className="text-neutral-500">--</span>
            )}
            <span className="text-neutral-500">{t.dashboard.vsPrevious}</span>
          </div>
        </div>
      </Card>
      <Card>
        <div className="p-4">
          <div className="text-sm text-neutral-500">{t.dashboard.totalRevenue}</div>
          <div className="text-2xl font-semibold">{centsToCurrency(totalRevenue, lang)}</div>
          <div className="flex items-center gap-1 text-xs mt-1">
            {hasPrevRevenue ? (
              <>
                {diffRevenue >= 0 ? (
                  <ArrowUpRight className="w-3 h-3 text-green-500" />
                ) : (
                  <ArrowDownRight className="w-3 h-3 text-red-500" />
                )}
                <span className={diffRevenue >= 0 ? "text-green-600" : "text-red-600"}>
                  {diffRevenue >= 0 ? "+" : ""}{diffPctRevenue.toFixed(1)}%
                </span>
              </>
            ) : (
              <span className="text-neutral-500">--</span>
            )}
            <span className="text-neutral-500">{t.dashboard.vsPrevious}</span>
          </div>
        </div>
      </Card>
    </div>
  );
}
